export enum MedicationsPermissions {
    ModuleOneCode = 'Medications',
    AccessCode = 'Medications_Access',
    WritePharmacyRequest = 'Medications_WritePharmacyRequest',
    ReadMedicationLists = 'Medications_ReadMedicationLists',
    WriteMedicationLists = 'Medications_WriteMedicationLists',

    PrescribeMedicationsTakeHomeScript = 'Medications_PrescribeMedicationsTakeHomeScript',
    PrescribeMedicationsMedicationOrder = 'Medications_PrescribeMedicationsMedicationOrder',
    PrescribeMedicationsMedicationHistory = 'Medications_PrescribeMedicationsMedicationHistory',
    PrescribeMedicationsEnrmcScript = 'Medications_PrescribeMedicationsAgeDisabilityScript', // String not replaced with eNRMC to preserve for A&D
    PrescribeComplementaryTherapyOrder = 'Medications_PrescribeComplementaryTherapyOrder',
    StopMedications = 'Medications_StopMedications',

    WriteUsers = 'ResourceManagement_WriteUsers',
    WriteStaffMembers = 'ResourceManagement_WriteStaffMembers',
    EncounterPerform = 'Encounter_Perform'
}
